<template>
  <div class="fm-container">
    <navgation-bar :isDefault="false">
      <template v-slot:nav-left>
        <div class="search-container-nav-left" @click="onBackClick">
          <!-- <img src="@img/back-2.svg" /> -->
          <img src="@img/back-white.svg" />
        </div>
      </template>
      <template v-slot:nav-center>
        <p class="search-container-nav-title">{{$t("app.home_ml")}}</p>
      </template>
    </navgation-bar>

    <div class="webview-container">
      <div class="frame-wrapper">
        <!-- <iframe class="webview-container"
                ref="iframe"
                id="show-iframe"
                :src="url"
                scrolling="no"></iframe> -->
        <iframe
          ref="inputRef"
          id="show-iframe"
          name="myframe"
          :src="url"
          frameborder="no"
          width="100%"
          border="0"
          marginwidth="0"
          marginheight="0"
          height="100%"
          allowtransparency="yes"
        />
      </div>
    </div>
  </div>
</template>

<script>
import NavgationBar from "@c/currency/NavigationBar";
import base from "../api/base"; // 导入接口域名列表
export default {
  data() {
    return {
      url: "",
    };
  },
  components: {
    NavgationBar
  },
  methods: {
    onBackClick() {
      this.$router.go(-1);
    },

  },
  created() {
   
    var id = this.$route.query.id;
    var url =  window.configUrl.baseURL  + "/mbs/api/item/" + id + "/file?type=" + 2;
    this.url = url;
  }
};
</script>

<style lang="scss" scoped>
@import "@css/style.scss";

.search-container {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column;

  &-nav-left {
    position: relative;
    width: 100%;
    img {
      position: absolute;
      left: 0;
      top: 50%;
      margin-top: px2rem(-13);
    }
  }

  &-nav-title {
    width: 100%;
    height: 100%;
    font-size: $titleSize;
    font-weight: bold;
    text-align: center;
    color: black;
  }
}

.fm-container {
  position: absoulte;
  width: 100%;
  height: 100%;
}
.frame-wrapper {
  display: flex;
  justify-content: center;
  height: 100%;
}
.webview-container {
  width: 100%;
  height: 100%;
}
.search-container-nav-title{


  color: white;
}
</style>
